<template>
  <v-app dark>
    <v-main>
      <NotificationContainer />
      <v-container py-8 px-6 fluid>
        <slot />
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { setDarkTheme } from '~/cynqueModules/nuxtAccessors'
import { useSettingsStore } from '~/stores/settings'

export default defineComponent({
  created() {
    this.setVuetifyTheme()
  },
  methods: {
    setVuetifyTheme() {
      setDarkTheme(useSettingsStore().useDarkMode)
    },
  },
})
</script>
